const requestPermission = async (): Promise<NotificationPermission> => {
  if (!Notification) return Promise.reject(new Error('Notification API is not supported'));
  if (Notification.permission === 'denied') return Promise.reject(Notification.permission);
  return Notification.requestPermission();
};

export default requestPermission;
